export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-11.2e739ed8.jpg";